import { AuthDataService } from './auth-data.service';
import { inject } from '@angular/core';
import { BugsnagService } from '@uzurv/core';
import { CanActivateFn } from '@angular/router';

export function AuthGuard(): CanActivateFn {
  return () => {
    const authDataService = inject(AuthDataService);
    const bugsnagService = inject(BugsnagService);

    if (authDataService.isLoggedIn) {
      return true;
    }

    bugsnagService.leaveBreadcrumb('Calling authDataService.logout in auth guard');
    authDataService.clearAuthData();
    return false;
  };
}
